export const colors = {
  "orange-1": "#ff7614",
  "orange-2": "#ff801e",
  "orange-3": "#ff8a28",
  "orange-4": "#ff9432",
  "orange-5": "#ff9e3c",
  "orange-6": "#ffa846",
  "orange-7": "#ffb250",
  "orange-8": "#ffbc5a",
  "orange-9": "#ffc664",
  "orange-10": "#ffd06e",
  "orange-11": "#ffda78",
  "orange-12": "#ffe482",
  "orange-13": "#ffee8c",
  "white": "#ffffff",
  "grey-11": "fbfbfb"
};
